import { MijnRoute } from '../../mijn-navigatie.model';

export const INCASSO_BATCHES_UPLOAD: MijnRoute = {
    path: 'upload',
    navigationEvent: 'toIncassobatchesUpload',
    regex: /^\/incassobatches\/upload$/,
    webcomponent: 'mijn-incassobatches-webcomponent',
    internalPath: '/upload'
};
